
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 1.33398V14.6673","stroke":"currentColor","stroke-width":"1.33333","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M10 12.666L8 14.666L6 12.666","stroke":"currentColor","stroke-width":"1.33333","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M12.668 6L14.668 8L12.668 10","stroke":"currentColor","stroke-width":"1.33333","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M1.33203 8H14.6654","stroke":"currentColor","stroke-width":"1.33333","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M3.33203 6L1.33203 8L3.33203 10","stroke":"currentColor","stroke-width":"1.33333","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M6 3.33398L8 1.33398L10 3.33398","stroke":"currentColor","stroke-width":"1.33333","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    